import { render, staticRenderFns } from "./ScannerReturns.vue?vue&type=template&id=10235c2f&scoped=true"
import script from "./ScannerReturns.vue?vue&type=script&lang=js"
export * from "./ScannerReturns.vue?vue&type=script&lang=js"
import style0 from "./ScannerReturns.vue?vue&type=style&index=0&id=10235c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10235c2f",
  null
  
)

export default component.exports